import { downloadCSV } from "react-admin";
import { unparse as convertToCSV } from "papaparse/papaparse.min";

const exporter = (enterpriseAdmins) => {
  const data = enterpriseAdmins.map((enterpriseAdmin) => ({
    id: enterpriseAdmin.id,
    empresa: enterpriseAdmin.enterprise_name,
    nome: enterpriseAdmin.name,
    email: enterpriseAdmin.email,
    master: (enterpriseAdmin.is_master === true ? 'Sim' : 'Não'),
    criado_em: enterpriseAdmin.created_at_format
  }));
  const csv = convertToCSV({
    data,
    fields: ["id", "empresa", "nome", "email", "master", "criado_em"]
  });
  downloadCSV(csv, "enterpriseAdmins");
};

export default exporter;
